import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898722641';
import { get_image_path } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/get_image_path.js?1733898722641';

export function get_src(product, attribute = 'thumbnail') {
    const path = get_attribute_value(product, attribute);
    // only use the path when it is not the default no_selection from magento2
    if (path && path !== 'no_selection') {
        return get_image_path(path);
    }
    return "/assets/magento2/default_image.png";
}
